import { sortBy } from "lodash";
import React from "react";

import { reactKeyFromIDSK } from "@examspark/common";
import {
  useQueryGetCourseViews,
  useQueryGetObjectivesViews,
} from "@examspark/common-app";
import { CardLink } from "@examspark/common-ui/dist/components/containers/LinkCard";
import { IconDocumentLine } from "@examspark/common-ui/dist/components/icons";
import { Course, Maybe, Resource } from "@examspark/types";

import { getUrlForObject } from "../../utils";
import { SidebarLinkItem } from "../classroom/sidebar/BasicSidebarListItem";
import SidebarBox from "../common/SidebarBox";

const getSidebarLabel = (doc: Resource) => {
  switch (doc.sk) {
    case "course-plan#v0":
      return `${doc.name} Year at a Glance (YAG)`;
    case "course-verification#v0":
      return `${doc.name} TEKS Verification Document (TVD)`;
    default:
      return doc.name;
  }
};

const CourseDocuments = (props: { course?: Maybe<Course> }) => {
  const specialCaseObjectivesViewBankMapping: Record<string, string> = {
    "tx-tcmpc/bluebonnet": "tx-tcmpc/trs",
  };

  const { data: objectivesViews } = useQueryGetObjectivesViews(
    props.course?.alignmentScopes,
    specialCaseObjectivesViewBankMapping[props.course?.bankId ?? ""] ??
      props.course?.bankId,
  );

  const { data: courseViews } = useQueryGetCourseViews(props.course?.id);

  if (!props.course) {
    return null;
  }

  const objectiveScope = encodeURIComponent(
    props.course.alignmentScopes?.[0] ?? "",
  );

  return (
    <SidebarBox title="Course Components">
      {sortBy(objectivesViews, ["type", "name"]).map((doc) => {
        const url = getUrlForObject(doc);
        if (url == null) return null;
        return (
          <SidebarLinkItem key={doc.id}>
            <IconDocumentLine width="24px" fill={"#666"} />
            <CardLink to={`${url}?objectiveScope=${objectiveScope}`}>
              {doc.name}
            </CardLink>
          </SidebarLinkItem>
        );
      })}
      {sortBy(courseViews, ["sk", "name"]).map((doc) => {
        let icon = <IconDocumentLine width="24px" />;
        switch (doc.type) {
          default:
            icon = <IconDocumentLine width="24px" fill="#666" />;
        }

        const url = getUrlForObject(doc);
        if (url == null) return null;
        return (
          <SidebarLinkItem key={reactKeyFromIDSK(doc)}>
            {icon}
            <CardLink to={url}>{getSidebarLabel(doc)}</CardLink>
          </SidebarLinkItem>
        );
      })}
    </SidebarBox>
  );
};

export default CourseDocuments;
